import { DFVariableCharges, MasterData } from './df-master-data.model';
import { UploadFileMasterDataMandatoryColumn } from './upload-file-master-data--mandatory-column';
import { UploadFileMasterDataColumn } from './upload-file-master-data-column';
import { UploadFileMasterDataParseError } from './upload-file-master-data-parse-error';


export class DFUploadMasterData {

  public failed: string;
  public failedRows: MasterData[];
  public missingColumns: UploadFileMasterDataColumn[];
  public missingMandatoryColumnValues: UploadFileMasterDataMandatoryColumn[];
  public parseErrors: UploadFileMasterDataParseError[]
  public reason: string;
  public status: string;
  public succeed: boolean;
  public successRows: MasterData[];
  public unexpectedColumns: { name: string, position: number }[];
  public failedImportReportByteStream: string;


  static fromDto(data: any): DFUploadMasterData {
    if (!data) {
      return null;
    }

    const importResult = new DFUploadMasterData();

    let failedRows: MasterData[] = [];

    let missingColumns: UploadFileMasterDataColumn[] = [];

    let missingMandatoryColumnValues: UploadFileMasterDataMandatoryColumn[] = [];

    let parseErrors: UploadFileMasterDataParseError[] = [];


    let successRows: MasterData[] = [];


    importResult.failed            = data.failed;
    importResult.status            = data.status;
    importResult.reason            = data.reason;
    importResult.succeed            = data.succeed ;
    importResult.unexpectedColumns = data.unexpected_columns || [];
    importResult.failedImportReportByteStream = data.failedImportReportByteStream;

    if (data.failedRows) {
      failedRows = data.failedRows.map(c => MasterData.fromDto(c));
    }

    if (data.missingColumns) {
      missingColumns = data.missingColumns.map(c => UploadFileMasterDataColumn.fromDto(c));
    }

    if (data.missingMandatoryColumnValues) {
      missingMandatoryColumnValues = data.missingMandatoryColumnValues.map(c => UploadFileMasterDataMandatoryColumn.fromDto(c));
    }

    if (data.parseErrors) {
      parseErrors = data.parseErrors.map(e => UploadFileMasterDataParseError.fromDto(e));
    }

    if (data.successRows) {
      successRows = data.successRows.map(c => MasterData.fromDto(c));
    }

    importResult.failedRows = failedRows;
    importResult.missingColumns = missingColumns;
    importResult.missingMandatoryColumnValues = missingMandatoryColumnValues;
    importResult.parseErrors = parseErrors;
    importResult.successRows = successRows;

    return importResult;
  }
}
